<template>
  <b-modal
    :active.sync="show"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    :width="1000"
    :height="600"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(save)">
        <div class="modal-card" style="width: 1000px">
          <header class="modal-card-head">
            <p class="modal-card-title">Change Sequence Title</p>
          </header>
          <section class="modal-card-body" style="height: 600px">
            <ValidationProvider
              v-slot="{ errors }"
              name="Title"
              rules="required"
            >
              <b-field
                class="has-margin-top-15"
                label="Title"
                :type="{ 'is-danger': errors.length > 0 }"
                :message="errors[0]"
              >
                <b-autocomplete
                  v-model="media.title"
                  placeholder="Select a title"
                  :data="filteredTitles"
                  field="title"
                  expanded
                  :open-on-focus="true"
                  @select="
                    (value) => {
                      if (value && value.id) {
                        selectedTitle = value
                      }
                    }
                  "
                />
              </b-field>
            </ValidationProvider>
            <BaseSelect
              v-if="selectedTitle && selectedTitle.media_type == 'series'"
              v-model="media.episode_id"
              label="Episode"
              :rules="'required'"
            >
              <option
                v-for="episode in episodes"
                :key="episode.id"
                :value="episode.id"
              >
                {{ episode.episode_number }}
                {{ episode.title ? `- ${episode.title}` : '' }}
              </option>
            </BaseSelect>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button class="button is-primary" type="button" @click="save">
              Update
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import BaseSelect from '@/components/BaseSelect'
import MediaChannelApi from '@/api/mediaChannels'
import EpisodesApi from '@/api/episodes'
import ScheduleApi from '@/api/schedules'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import { sortBy } from 'lodash'

export default {
  name: 'ChangeSequenceTitleModal',
  components: {
    BaseSelect,
  },
  mixins: [Filters, Utils],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channelId: {
      type: Number,
      default: null,
    },
    repeatsId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      media: {},
      titles: [],
      episodes: [],
      selectedTitle: {},
    }
  },
  computed: {
    filteredTitles() {
      if (this.media && this.media.title) {
        let filter = this.media.title.toLowerCase()
        return this.titles.filter((item) =>
          item.title.toLowerCase().includes(filter)
        )
      }
    },
  },
  watch: {
    async selectedTitle(newVal, oldVal) {
      if (this.selectedTitle && this.selectedTitle.media_type === 'series') {
        let episodes = await EpisodesApi.getAllByMediaId(this.selectedTitle.id)
        episodes.forEach(
          (episode) =>
            (episode.episode_number = parseInt(episode.episode_number, 10))
        )
        this.episodes = sortBy(episodes, 'episode_number')
      }
    },
  },
  async created() {
    let titles = await MediaChannelApi.getByChannelId(this.channelId)
    titles.forEach((item) => {
      let mediadata = null
      if (item.mediadata) {
        mediadata = JSON.parse(item.mediadata)
      }
      item.title =
        item.title +
        (item.media_type === 'series' && mediadata && mediadata.seriesNo
          ? ` S${mediadata.seriesNo}`
          : '') +
        ` - ${this.$options.filters.capitalize(item.media_type)}`
    })
    this.titles = titles
    this.initialized = true
  },
  methods: {
    getTitle(item) {
      if (item.media_type === 'movie') {
        return item.media_title
      } else {
        return `${item.media_title} S${item.mediadata.seriesNo} E${item.episode_number}`
      }
    },
    formatTime(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm')
    },
    async save() {
      await ScheduleApi.updateSequenceTitle({
        repeats_id: this.repeatsId,
        media_id: this.selectedTitle.id,
        episode_id: this.media.episode_id,
      })
      this.$buefy.toast.open({
        message: 'Sequence title updated successfully!',
        position: 'is-top',
        type: 'is-success',
      })
      this.closeModal()
      this.$emit('refresh')
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this sequence?',
        onConfirm: async () => {
          this.loading = true
          await ScheduleApi.deleteSequence(this.repeatsId)
          this.$buefy.toast.open({
            message: 'Sequence removed successfully!',
            position: 'is-top',
            type: 'is-success',
          })
          this.loading = false
          this.$emit('refresh')
          this.closeModal()
        },
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
